import { XMLParser, XMLBuilder } from 'fast-xml-parser';

const xmlParserOptions = {
  ignoreAttributes: false,
  attributeNamePrefix: '@_',
  textNodeName: '#text',
  parseAttributeValue: false,
  trimValues: true,
  parseTrueNumberOnly: false,
  allowBooleanAttributes: true
};

const xmlBuilderOptions = {
  ignoreAttributes: false,
  attributeNamePrefix: '@_',
  textNodeName: '#text',
  format: false,
  suppressEmptyNode: false
};

export function parseXmlToHtml(xmlContent: string): string {
  try {
    const parser = new XMLParser(xmlParserOptions);
    const parsedXml = parser.parse(xmlContent);
    
    const builder = new XMLBuilder(xmlBuilderOptions);
    const htmlString = builder.build(parsedXml);
    
    return cleanHtmlOutput(htmlString);
  } catch (error) {
    console.warn('XML parsing failed:', error);
    return xmlContent;
  }
}

function cleanHtmlOutput(htmlString: string): string {
  return htmlString
    .replace(/@_version="[^"]*"/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

export function isXmlContent(content: string): boolean {
  return /<[^>]+>/.test(content.trim());
}
